module.exports = __webpack_public_path__ + "media/images/edion/top/5-6fe614137e0c6bef18484523581ee7b6.png";